var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card shadow" }, [
    _c("div", { staticClass: "card-header py-3" }, [
      _c("h6", { staticClass: "m-0 font-weight-bold text-primary" }, [
        _vm._v(_vm._s(_vm.$t("txtAccount")))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-group row align-items-center mb-0" }, [
        _c(
          "label",
          { staticClass: "col-sm-4 col-form-label small text-muted" },
          [_vm._v("\n        " + _vm._s(_vm.$t("comSelected")) + "\n      ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-8" },
          [
            _c("v-select", {
              attrs: {
                options: _vm.selectOptions,
                reduce: option => option.value,
                placeholder: _vm.$t("comSelected")
              },
              on: { input: _vm.onValueChange },
              scopedSlots: _vm._u([
                {
                  key: "no-options",
                  fn: function({ search, searching }) {
                    return [
                      searching
                        ? [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("general.noData")) +
                                " "
                            ),
                            _c("em", [_vm._v(_vm._s(search))]),
                            _vm._v(".\n            ")
                          ]
                        : _c("em", [_vm._v(_vm._s(_vm.$t("txtInputNeeded")))])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.vm.selectedItem,
                callback: function($$v) {
                  _vm.$set(_vm.vm, "selectedItem", $$v)
                },
                expression: "vm.selectedItem"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }